import script from "./TableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=js"

import "./TableRow.vue?vue&type=style&index=0&id=13803a27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13803a27"]])

export default __exports__